import {mapState, mapMutations, mapGetters} from 'vuex'
import {getLabel} from '@/utils/Institution'

import {userRoleIs, userProvides, SPECIALIST, MEDICAL_TECHNOLOGY} from "../utils/Specialist";

export default {
    computed:{
        ...mapGetters(['isOnBoardingDone']),
        ...mapState(['currentUser', 'currentProvider', 'globalLoading', 'isDark']),
        appName(){
          return 'Kyra'
        },
        clientSingular(){
            return getLabel('commons.client.singular')
        },
        clientPlural(){
            return getLabel('commons.client.plural')
        },
        userIsSpecialist(){
            return userRoleIs(SPECIALIST)
        },
        userIsTechnologist(){
            return userProvides(MEDICAL_TECHNOLOGY)
        },
        isInstitution(){
            const vm = this
            return !!vm.currentProvider && !!vm.currentProvider.institution
        },
        isOwner(){
            var vm = this
            return   !!vm.currentProvider && vm.currentProvider.role.is_owner
        },
        isOwnerOrAdmin(){
            var vm = this
            return !!vm.currentProvider && (vm.currentProvider.role.is_owner || vm.currentProvider.role.is_admin)
        },
        isMobile(){
            const vm = this
            return vm.$vuetify.breakpoint.smAndDown
        },
        isMD(){
            const vm = this
            return vm.$vuetify.breakpoint.md
        }
    },
    methods:{
        ...mapMutations(['showSnackBar', 'setGlobalLoading']),
        toast(message = '', color = 'success'){
            const vm = this
            vm.showSnackBar({
                text: message,
                color: color
            })
        }
    }
}
